import AppAbortController from '@/api/abort-controller'
import ApiHandler from '@/api/base'

const abortController = new AppAbortController()

class ObjectiveChartsApiHandler extends ApiHandler {
  async getChartDataForElement({ elementId, granulation = null, workspaceId }) {
    const { data } = await this.http.get('/chart/element', {
      params: {
        elementId,
        granulation,
        workspaceId
      },
      signal: abortController.getSignal(this.constructor.name, 'getChartDataForElement')
    })

    return data
  }
}

export default ObjectiveChartsApiHandler
